import React, { Fragment, useState } from "react";
import Spinner from "./common/Spinner";
import icon1 from "../assets/img/marketplace/1.png";
import icon2 from "../assets/img/marketplace/2.png";
import icon3 from "../assets/img/marketplace/3.png";
import icon4 from "../assets/img/marketplace/4.png";
import icon5 from "../assets/img/marketplace/5.png";
import icon6 from "../assets/img/marketplace/5.png";
import metrics from "../helpersjson/Metrics.json";
import { TfiAngleLeft } from "react-icons/tfi";
import { BsThreeDots } from "react-icons/bs";
import { CgExport } from "react-icons/cg";
import Api from "../api/api";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LineChart from "./dashbaord/Linechart";
import moment from "moment/moment";
const iconMap = {
  icon1: icon1,
  icon2: icon2,
  icon3: icon3,
  icon4: icon4,
  icon5: icon5,
  icon6: icon6,
};

const Result = () => {
  const [activeTab, setActiveTab] = useState("backTesting");
  const [results, setResults] = useState([]);
  const [dayrunDetails, setdayrunDetails] = useState({});
  const [singleResults, setSingleResults] = useState([]);
  const [selectedResults, setSelectedResults] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [openSections, setOpenSections] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const location = useLocation();
  const [filteredDaydetailsData, setfilteredDaydetailsData] = useState([]);
  const { data } = location.state || 0;
  const navigate = useNavigate();
  
  // Keyboard navigation handlers
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Don't trigger if user is typing in an input field
      const isInputFocused = e.target.tagName === 'INPUT' || 
                            e.target.tagName === 'TEXTAREA' ||
                            e.target.isContentEditable;
      
      // Backspace key - go back (only when not in input)
      if (e.key === 'Backspace' && !isInputFocused) {
        // Check if we're at the top of the page to avoid browser back navigation
        if (window.scrollY === 0) {
          e.preventDefault();
          navigate('/strategies');
        }
      }
      
      // Escape key - go back to strategies
      if (e.key === 'Escape' && !isInputFocused) {
        e.preventDefault();
        navigate('/strategies');
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);
  
  const toggleAccordion = (item, index) => {
    if (openSections === index) {
      // If clicking on the same section, just close it
      setOpenSections(null);
    } else {
      // If opening a new section, show spinner and fetch data
      setIsLoadingDetails(true);
      setOpenSections(index);
      getrundetailsBydate(item, index);
    }
  };
  const resultsDayDetailsHeader = [
    "Symbol Type",
    "Symbol",
    "Order Type",
    "Quantity",
    "Price",
    "Timestamp",
    "PNL",
  ];
  const accrodionHeader = [
    { key: "run_date" },
    { key: "day" },
    { key: "pnl", title: "Average PNL", icon: "icon3" },
  ];

  async function getResults() {
    const payload = {
      strategy_id: data.strategy_id,
      run_type: activeTab === "backTesting" ? "B" : "L",
    };
    try {
      let res = await Api.results(payload);

      setResults(res.data);
      // getrunschart()
      setSelectedResults(res.data[0]);
      if (res.data.length > 0) {

        getrunschart(res.data[0]);
      }
    } catch (error) {
      alert("Error while fetching Strategies");
    }
  }

  async function getrundetailsBydate(data, index) {
    const payload = {
      run_id: selectedResults?.run_id,
      run_type: activeTab === "backTesting" ? "B" : "L",
      run_date: data?.run_date,
    };
    try {
      let res = await Api.getdayrunDetaisl(payload);
      const position = JSON.parse(res.data[0].position);
      setdayrunDetails(position);
      // setfilteredDaydetailsData(
      //   position?.ENTRIES?.filter((row) => !row.hasOwnProperty("PNL"))
      // );
    } catch (error) {
      alert("Error while fetching Strategies");
    } finally {
      setIsLoadingDetails(false);
    }
  }

  async function getrunschart(data) {
    const payload = {
      run_id: data?.run_id,
      run_type: activeTab === "backTesting" ? "B" : "L",
    };
    try {
      let res = await Api.runresults(payload);
      setSingleResults(res.data);
    } catch (error) {
      alert("Error while fetching Strategies");
    }
  }
  useEffect(() => {
    getResults();
  }, [activeTab]);

  useEffect(() => {
    if (singleResults?.run_days?.length > 0) {
      setIsLoadingDetails(true);
      getrundetailsBydate(singleResults.run_days[0], 0);
      setOpenSections(0)
    }
  }, [singleResults]);

  return (
    <div className="row flex-wrap mt-5">
      {/* Left Content */}
      <div className="col-12 col-md-4">
        <div className="strategies-detail-header d-flex align-items-center gap-2">
          <div
            className="icon d-flex align-items-center justify-content-center cursor-pointer"
            onClick={() => navigate("/strategies")}
          >
            <TfiAngleLeft />
          </div>
          <div className="text">
            <h4 className="fw-semibold lh-base text-heading">
              {data.strategy_name}
            </h4>
            {data.published_user && (
              <p className="fs-14 lh-base fw-medium mt-1">
                By:{" "}
               
                  {data.published_user}
                
              </p>
            )}
          </div>
        </div>

        {/* <div className="d-flex align-items-center button">
        {tags.map((item, index) => (
          <span
            className="fs-12 lh-base fw-medium"
            style={{ backgroundColor: colors[index % colors.length] }}
          >
            {item}
          </span>
        ))}
        {/* <span className='fs-12 lh-base fw-medium text-heading'>Marketplace</span> */}
        {/* </div> */}
        <div className="custom-tabs mb-3  d-flex justify-content-start m-0 mt-2">
          <button
            className={`tab-btn ${activeTab === "backTesting" ? "active" : ""}`}
            onClick={() => setActiveTab("backTesting")}
          >
            Back Testing
          </button>
          <button
            className={`tab-btn ${activeTab === "liveRuns" ? "active" : ""}`}
            onClick={() => setActiveTab("liveRuns")}
          >
            Live Runs
          </button>
        </div>

        <div className="table-responsive">
          <table className="table align-middle text-center border table-hover">
            <thead className="">
              <tr style={{ background: "#E6FFFA" }}>
                <th scope="col">Run Date</th>
                <th scope="col">Win (%)</th>
                <th scope="col">Strategy Status</th>
              </tr>
            </thead>
            <tbody>
              {results?.map((item, index) => (
                <tr
                  className={`${selectedResults?.run_id === item.run_id ? 'table-active' : ''}`}
                  key={index}
                  onClick={() => {
                    setSelectedResults(item);
                    getrunschart(item);
                  }}
                >
                  <td>{item.run_ts}</td>
                  <td>{item.metrics.win_pct}</td>
                  <td>
                    <span
                      className={`badge bg-${
                        item.run_status === "Completed" ? "success" : "danger"
                      }`}
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        display: "inline-block",
                      }}
                    ></span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Right Content */}

      {selectedResults ? (
        <div className="col-12 col-md-8">
          {/* {selectedResults.run_id} */}
          <div className="strategies-btn d-flex align-items-center justify-content-end">
            <div className="btn-wrap">
              <button to="" className="btn">
                <BsThreeDots />
              </button>
              <button to="" className="btn">
                <CgExport />
              </button>
              <div>
                <span className="pt-1 text-dark fw-bold">Export</span>
              </div>
            </div>
          </div>
          <div className=" row card mt-3">
            <div className="card-body">
              <div className="row">
                <div className="col-md-2 col-sm-4 mb-3 mb-md-0">
                  <div className="headtab">Start Date</div>
                  <div className="border rounded p-2 mt-2 headTab2">
                    {moment(selectedResults?.start_date_time).format("L")}
                  </div>
                </div>
                <div className="col-md-2 col-sm-4 mb-3 mb-md-0">
                  <div className="headtab">End Date</div>
                  <div className="border rounded p-2 mt-2 headTab2">
                    {moment(selectedResults?.end_date_time).format("L")}
                  </div>
                </div>
                <div className="col-md-2 col-sm-4 mb-3 mb-md-0">
                  <div className="headtab">Overall PnL</div>
                  <div className="border rounded p-2 mt-2 headTab2">
                    {selectedResults?.metrics?.overall_pnl}
                  </div>
                </div>
                <div className="col-md-2 col-sm-4">
                  <div className="headtab">Strategy Type</div>
                  <div className="border rounded p-2 mt-2 headTab2 ">
                    {selectedResults.metrics?.trade_type}
                  </div>
                </div>
                <div className="col-md-2 col-sm-4">
                  <div className="headtab">Interval</div>
                  <div className="border rounded p-2 mt-2 headTab2 ">
                    {selectedResults.metrics?.run_interval || "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row card mt-3">
            <div className="card-body">
              {/* <img
                src={imagePng}
                alt={""}
                className="img-fluid"
                style={{ width: "100%", height: "100%", display: "block" }}
              /> */}
              {singleResults?.chart_data &&
                singleResults?.chart_data.length > 0 && (
                  <LineChart
                    chartdata={singleResults?.chart_data}
                    borderColor={"#5ed9bf"}
                  />
                )}
            </div>
          </div>

          <div className="row mt-2 g-3 d-flex justify-content-between">
            <div className="row col-12 col-lg-6 mt-2">
              <div className="card">
                <div className="card-body">
                  <span className="subHeadings">Metric Details</span>
                  <div className="all-valur-history mb-3 d-grid grid-count-3 gap-2">
                    {metrics?.metrics?.map((itm, iddx) => (
                      <div
                        className="total-value mb-2 d-flex align-items-center gap-2 p-2"
                        key={iddx}
                      >
                        <div className="image-area">
                          <img src={iconMap[itm.icon]} alt="" />
                        </div>
                        <div className="values">
                          {selectedResults.metrics && (
                            <p className="mb-1 price">
                              {selectedResults.metrics[itm.key]
                                ? selectedResults.metrics[itm.key]
                                : 0}
                            </p>
                          )}
                          <p className="price2">{itm.title}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className=" row col-12 col-lg-6 mt-2">
              <div className="card ">
                <div className="card-body">
                  <span className="subHeadings">Day Details</span>
                  <div className="all-valur-history mb-3 d-grid grid-count-3 gap-2">
                    {singleResults?.day_pnl && Object.keys(singleResults.day_pnl).length > 0 ? (
                      singleResults?.day_pnl?.map((itm, iddx) => (
                        <div
                          className="total-value mb-2 d-flex align-items-center gap-2 p-2"
                          key={iddx}
                        >
                          <div className="values">
                            <p className="mb-1 price">{itm.day}</p>
                            <p className="price2">Amount : {itm.pnl}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12 text-center">No day details available</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-4 card">
            <div className="card-body border">
              {/* <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <div className="accordion-header" id="headingOne">
              <div
                className="d-flex justify-content-between accordion-button collapsed accordion border"
                role="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
                tabIndex={0}
              >
                <span>Date</span>
                <span>Monday</span>
                <span>P/L (%)</span>
              </div>
            </div>

            <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne">
              <div className="accordion-body d-flex justify-content-between">
                <span>Instrument 1</span>
                <span>+6.64%</span>
              </div>
            </div>
          </div>
        </div> */}
              <div>
                <span className="subHeadings">Details</span>
                {singleResults?.run_days && singleResults.run_days.length > 0 ? (
                  singleResults.run_days.map((table, index) => (
                    <table key={index} className="col-12 border border-gray-300">
                      <thead className="accord-head cursor-pointer">
                        <tr className="d-flex justify-content-between align-items-center">
                          {accrodionHeader.map((heading, idx) => (
                            <React.Fragment key={idx}>
                              {table.key == "run_date" ? (
                                <span key={`span-${idx}`}>
                                  <th
                                    className="p-2"
                                    onClick={() => toggleAccordion(table)}
                                  >
                                    &#9660;
                                  </th>
                                  <th key={`th-${idx}`} className=" p-2">
                                    {table[heading.key]}
                                  </th>
                                </span>
                              ) : (
                                <th
                                  key={`th-${idx}`}
                                  className=" p-2"
                                  onClick={() => toggleAccordion(table, index)}
                                >
                                  {table[heading.key]}
                                </th>
                              )}
                            </React.Fragment>
                          ))}
                        </tr>
                      </thead>
                      {openSections === index && (
                        <tbody>
                          {isLoadingDetails ? (
                            <tr>
                              <td colSpan="7" className="text-center p-4">
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                  <Spinner size="sm" text="Loading details..." />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <table className="col-12 border border-gray-300">
                              <thead>
                                <tr className="bg-gray-100">
                                  {resultsDayDetailsHeader?.map((item, index) => (
                                    <Fragment key={index}>
                                      <th className="border p-2">{item}</th>
                                    </Fragment>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {dayrunDetails?.ENTRIES?.map((item, index) => (
                                  <tr className="border" key={`entry-${index}`}>
                                    {Object.entries(item).map(([key, value], i) =>
                                      i !== 2 && i !== 3 && key !== "PNL" ? (
                                        <React.Fragment key={`fragment-${index}-${i}`}>
                                          <td className="border p-2" key={`key-${index}-${i}`}>{key}</td>
                                          <td className="border p-2" key={`value-${index}-${i}`}>
                                            {value ? value : "-"}
                                          </td>
                                        </React.Fragment>
                                      ) : (
                                        <td className="border p-2" key={`cell-${index}-${i}`}>
                                          {value ? value : "-"}
                                        </td>
                                      )
                                    )}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </tbody>
                      )}
                    </table>
                  ))
                ) : (
                  <div className="text-center p-3">No run details available</div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Result;